<template>
  <gift-card
    class="selected-gift-card"
    variant="primary"
    :logo_src="product.logo_white"
    :category="product.category"
    :validity="validity"
  >
    <gift-card-value :amount="selected_amount" />
  </gift-card>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import { VALIDITY_LABEL } from '@livegift/resources';
  import GiftCardValue from '@livegift/components/blocks/gift-card/gift-card-value.vue';

  export default {
    name: 'selected-gift-card',

    components: {
      'gift-card-value': GiftCardValue,
    },

    computed: {
      ...mapState('livegift', ['selected_amount']),
      ...mapGetters('livegift', { product: 'selected_product_data' }),

      validity: () => VALIDITY_LABEL,
    },
  };
</script>
